/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Notebook
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define('notebook/NewDatasetActionHandler', [ 'notebook/bundles/component.min' ], entry => entry.NewDatasetActionHandler);
define('notebook/NotebookSaveActionHandler', [ 'notebook/bundles/component.min' ], entry => entry.NotebookSaveActionHandler);
define('notebook/NotebookView', [ 'notebook/bundles/component.min' ], entry => entry.NotebookView);

define('notebook/bundles/component.bridge', () => {});
